// Where the API is, and nothing else.
//
// IN DEVELOPMENT THIS IS AN EMPTY STRING, ON PURPOSE. Vite proxies /api to the
// ASP.NET host (see vite.config.js), so a relative URL is same-origin from the
// browser's point of view: no CORS preflight, and no second origin to keep in
// the server's Academy:FrontendUrl allowlist.
//
// In a published build the SPA is served out of Academy.Server/wwwroot by the
// same host that serves the API, so a relative URL is again correct. The env var
// exists only for the case those two come apart — a CDN-hosted client, or a
// preview build pointed at staging. Set it and the server's
// Academy:AdditionalFrontendUrls must list this client's origin, or the browser
// will reject responses the server logged as 200.
const configured = import.meta.env.VITE_API_BASE_URL ?? '';

/** Origin of the API host. Empty string means "same origin as this page". */
export const apiOrigin = configured.replace(/\/+$/, '');

/** Every controller in this API lives under this prefix. */
export const API_BASE_PATH = '/api/academy';

/** Base URL for the http client. `/api/academy` when same-origin. */
export const apiBaseUrl = `${apiOrigin}${API_BASE_PATH}`;

export const isDev = import.meta.env.DEV;

// WHERE THE PUBLIC FORMS POST, and the one URL in this app that is not this
// app's API. Both public forms — Get-in-touch on the landing page and
// self-service /register — are ONE FUNNEL into the CRM's anonymous intake
// (`POST /api/leads`); the Academy creates nobody from them. A lead becomes a
// Person only when someone in the CRM converts it.
//
// Absolute and cross-origin by necessity: the CRM is a different host, so the
// browser preflights this. The CRM allows exactly one origin (Crm:AcademyOrigin)
// and exactly `POST` + `Content-Type` — do not add headers to the request.
//
// Empty means "not configured", and the forms say so out loud rather than
// posting into the void: a deployed build with this unset would otherwise
// swallow every enquiry.
export const crmIntakeUrl = (import.meta.env.VITE_CRM_INTAKE_URL ?? '').replace(/\/+$/, '');

// THE CAPTCHA'S PUBLIC HALF. Cloudflare Turnstile's site key is public by
// design — it is baked into the page and shown to every visitor — and the
// secret that verifies the token lives only on the CRM, which is the side that
// checks it.
//
// CONFIGURED-OR-OFF. Empty means the widget renders nothing and the form posts
// without a token, which mirrors the CRM's own posture: an unset secret there
// disables verification in development and FAILS STARTUP in Production. So a
// developer running the landing page locally is not made to hold a Cloudflare
// account, and the two halves cannot end up configured on one side only in an
// environment where it matters.
//
// It is also what decides whether challenges.cloudflare.com needs to be in the
// server's SECURITY__SCRIPTSRC and SECURITY__FRAMESRC — both, not one.
export const turnstileSiteKey = (import.meta.env.VITE_TURNSTILE_SITE_KEY ?? '').trim();

// WHERE AN INSTRUCTOR APPLIES, and the one other URL in this app that is not
// this app's own API or the CRM's. The Academy has no application flow of its
// own for this: the sibling Careers site (a separate public site, backed by
// its own HRM) hosts a dedicated, unlisted page for it — not one of the
// site's open job postings, reachable only by direct link. This is a PLAIN
// OUTBOUND LINK, never a fetch: the landing page's job is to invite the right
// reader and hand them off, not to talk to that site's backend.
//
// Defaulted rather than empty-means-off, unlike `crmIntakeUrl` above: there is
// no anonymous submission happening here for a missing value to silently
// swallow, only a link a visitor can retry at the Careers site directly if
// this default ever drifts from its real address.
export const careersInstructorApplyUrl = (
    import.meta.env.VITE_CAREERS_INSTRUCTOR_APPLY_URL
    ?? 'https://careers.binaa-almajal.com/apply/instructor'
).replace(/\/+$/, '');

// GOOGLE ANALYTICS 4, CONFIGURED-OR-OFF like the CAPTCHA above. The measurement
// id is public (it is in every page Google tags) and the deploy sets it from a
// repository variable. Empty — every local build — loads nothing, so
// development traffic never lands in the production property.
export const gaMeasurementId = (import.meta.env.VITE_GA_MEASUREMENT_ID ?? '').trim();
